// extracted by mini-css-extract-plugin
module.exports = {"postal_code_input":"postalCodeInput_postal_code_input__M24Xs"};